import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/components/brand/Logo';
import { Button } from '@/components/ui/Button';
import styles from './LandingPage.module.css';

const FEATURE_KEYS = ['sharedClarity', 'privateByDefault', 'effortless'] as const;
const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4'] as const;
const STEP_KEYS = ['1', '2', '3'] as const;

export function LandingPage() {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Logo size="md" />
        <nav className={styles.headerNav}>
          <Link to="/privacy">{t('landing.privacyLink')}</Link>
          <Link to="/terms">{t('landing.termsLink')}</Link>
        </nav>
      </header>

      <section className={styles.hero}>
        <div className={styles.heroCopy}>
          <Logo size="lg" className={styles.heroLogo} />
          <h1 className={styles.slogan}>{t('brand.slogan')}</h1>
          <p className={styles.description}>{t('landing.description')}</p>
          <Link to="/app" className={styles.ctaLink}>
            <Button variant="primary">{t('landing.cta')}</Button>
          </Link>
        </div>

        <div className={styles.mock} aria-hidden="true">
          <div className={styles.mockBar} />
          <div className={styles.mockGrid}>
            {Array.from({ length: 35 }, (_, i) => (
              <span
                key={i}
                className={styles.mockCell}
                data-active={i === 12 || i === 18 ? 'true' : undefined}
              />
            ))}
          </div>
          <div className={styles.mockPlans}>
            <span />
            <span />
            <span />
          </div>
        </div>
      </section>

      <section className={styles.features}>
        {FEATURE_KEYS.map((key) => (
          <article key={key} className={styles.featureCard}>
            <h2>{t(`landing.features.${key}.title`)}</h2>
            <p>{t(`landing.features.${key}.body`)}</p>
          </article>
        ))}
      </section>

      <section className={styles.howItWorks}>
        <h2>{t('landing.howItWorks.title')}</h2>
        <ol>
          {STEP_KEYS.map((step) => (
            <li key={step}>{t(`landing.howItWorks.steps.${step}`)}</li>
          ))}
        </ol>
      </section>

      <section className={styles.privacyBlock}>
        <h2>{t('landing.privacy.title')}</h2>
        <p>{t('landing.privacy.body')}</p>
      </section>

      <section className={styles.faq}>
        <h2>{t('landing.faq.title')}</h2>
        <dl>
          {FAQ_KEYS.map((key) => (
            <div key={key} className={styles.faqItem}>
              <dt>{t(`landing.faq.items.${key}`)}</dt>
              <dd>{t(`landing.faq.items.a${key.slice(1)}`)}</dd>
            </div>
          ))}
        </dl>
      </section>

      <footer className={styles.footer}>
        <p>{t('landing.footer')}</p>
        <div className={styles.footerLinks}>
          <Link to="/privacy">{t('landing.privacyLink')}</Link>
          <Link to="/terms">{t('landing.termsLink')}</Link>
        </div>
      </footer>
    </div>
  );
}
